import api from "./api";

export const listDiscipline = async (params?: any) => {
    const { data } = await api.get('products/discipline/', {params: params});
    return data
}

export const detailDiscipline = async (id: string) => {
    const { data } = await api.get('products/discipline/'+ id);

    return data
}

// Manarger Services
export const createMaterial = async(type:string, params: any) => {
    let url = 'manager/';

    if(type === 'Discipline'){
        url += 'discipline/'
    }else if(type === 'Unity' || type === 'Item'){
        url += 'item/'
    }else if(type === 'Theme'){
        url += 'theme/'
    }else if(type === 'Object'){
        url += 'media/'
    }
    const {data} = await api.post(url, params)
    return data
}

export const editMaterial = async(id:any, type:string, params: any) => {
    let url = 'manager/';

    if(type === 'Discipline'){
        url += 'discipline/'
    }else if(type === 'Unity' || type === 'Item'){
        url += 'item/'
    }else if(type === 'Theme'){
        url += 'theme/'
    }else if(type === 'Object' || type === 'Media'){
        url += 'media/'
    }

    url += id

    const {data} = await api.put(url, params)
    return data
}

export const listShortDisciplineManager = async (params?: any) => {
    const { data } = await api.get('manager/short_discipline/', {params: params});
    return data
}

export const listDisciplineManager = async (params?: any) => {
    const { data } = await api.get('manager/discipline/', {params: params});
    return data
}

export const detailDisciplineManager = async (id: string) => {
    const { data } = await api.get('manager/discipline/' + id);
    return data
}

export const setItemsToDisciplinaManager = async (params: any) => {
    const { data } = await api.post('manager/discipline/items/', params);
    return data
}



